module.exports = __webpack_public_path__ + "static/media/xternal-link.712830f4.svg";